import axios from "axios";
import { api } from "./helper";
import CryptoJS from 'crypto-js';
import Utils from "@/project/Source/utils.js";

const client = axios.create({
  baseURL: api,
  withCredentials: false,
});

client.interceptors.request.use((config) => {
  config.headers.Authorization = "Bearer " + JSON.parse(CryptoJS.AES.decrypt(window.localStorage.getItem('jwt'), 'secret_key').toString(CryptoJS.enc.Utf8));
  return Utils.applyRequestCorrelationId(config);
});

client.interceptors.response.use(
  (response) => {
    if (response.data.isSuccess)
      return response;
    else {
      const message = Utils.FormatErrorWithCorrelationId(null, response);
      Utils.Alert(message);
    }
  },
  (error) => {
    if (error.response?.status === 401) {
      Utils.redirectToLoginOnUnauthorized();
      return Promise.reject(error);
    }
    const message = Utils.FormatErrorWithCorrelationId(error);
    Utils.Alert(message);
    return Promise.reject(error);
  }
);


function Login(item) {
  return client.post("SystemAuth/Login", item);
}























function ServiceClass(item) {
  return client.post("Dictionary/ServiceClass", item);
}

function Service(item) {
  return client.post("Dictionary/Service", item);
}

function NewServiceClassRequest(item) {
  return client.post("Dictionary/NewServiceClassRequest", item);
}

function DropServiceClassRequest(item) {
  return client.post("Dictionary/DropServiceClassRequest", item);
}

function EditServiceClassRequest(item) {
  return client.post("Dictionary/EditServiceClassRequest", item);
}

function NewServiceRequest(item) {
  return client.post("Dictionary/NewServiceRequest", item);
}

function DropServiceRequest(item) {
  return client.post("Dictionary/DropServiceRequest", item);
}

function EditServiceRequest(item) {
  return client.post("Dictionary/EditServiceRequest", item);
}

function ServiceByClass(item) {
  return client.post("Dictionary/ServiceByClass", item);
}
function ServiceByName(item) {
  return client.post("Dictionary/ServiceByName", item);
}
function ServiceReportTemplateDetail(item) {
  return client.post("Dictionary/ServiceReportTemplateDetail", item);
}
function ServiceReportTemplate(item) {
  return client.post("Dictionary/ServiceReportTemplate", item);
}
function NewServiceReportTemplateRequest(item) {
  return client.post("Dictionary/NewServiceReportTemplateRequest", item);
}
function DropServiceReportTemplateRequest(item) {
  return client.post("Dictionary/DropServiceReportTemplateRequest", item);
}
function EditServiceReportTemplateRequest(item) {
  return client.post("Dictionary/EditServiceReportTemplateRequest", item);
}
function NewServiceReportTemplateDetailRequest(item) {
  return client.post("Dictionary/NewServiceReportTemplateDetailRequest", item);
}
function DropServiceReportTemplateDetailRequest(item) {
  return client.post("Dictionary/DropServiceReportTemplateDetailRequest", item);
}
function ServiceClaimTemplateDetail(item) {
  return client.post("Dictionary/ServiceClaimTemplateDetail", item);
}
function ServiceClaimTemplate(item) {
  return client.post("Dictionary/ServiceClaimTemplate", item);
}
function NewServiceClaimTemplateRequest(item) {
  return client.post("Dictionary/NewServiceClaimTemplateRequest", item);
}
function DropServiceClaimTemplateRequest(item) {
  return client.post("Dictionary/DropServiceClaimTemplateRequest", item);
}
function EditServiceClaimTemplateRequest(item) {
  return client.post("Dictionary/EditServiceClaimTemplateRequest", item);
}
function NewServiceClaimTemplateDetailRequest(item) {
  return client.post("Dictionary/NewServiceClaimTemplateDetailRequest", item);
}
function DropServiceClaimTemplateDetailRequest(item) {
  return client.post("Dictionary/DropServiceClaimTemplateDetailRequest", item);
}
function Position(item) {
  return client.post("Dictionary/Position", item);
}
function DropPositionRequest(item) {
  return client.post("Dictionary/DropPositionRequest", item);
}
function EditPositionRequest(item) {
  return client.post("Dictionary/EditPositionRequest", item);
}
function NewPositionRequest(item) {
  return client.post("Dictionary/NewPositionRequest", item);
}
function Department(item) {
  return client.post("Dictionary/Department", item);
}
function DropDepartmentRequest(item) {
  return client.post("Dictionary/DropDepartmentRequest", item);
}
function EditDepartmentRequest(item) {
  return client.post("Dictionary/EditDepartmentRequest", item);
}
function NewDepartmentRequest(item) {
  return client.post("Dictionary/NewDepartmentRequest", item);
}
function Doctor(item) {
  return client.post("Dictionary/Doctor", item);
}
function DropDoctorRequest(item) {
  return client.post("Dictionary/DropDoctorRequest", item);
}
function EditDoctorRequest(item) {
  return client.post("Dictionary/EditDoctorRequest", item);
}
function NewDoctorRequest(item) {
  return client.post("Dictionary/NewDoctorRequest", item);
}
function ProgramTemplateDetail(item) {
  return client.post("Dictionary/ProgramTemplateDetail", item);
}
function ProgramTemplate(item) {
  return client.post("Dictionary/ProgramTemplate", item);
}
function NewProgramTemplateRequest(item) {
  return client.post("Dictionary/NewProgramTemplateRequest", item);
}
function DropProgramTemplateRequest(item) {
  return client.post("Dictionary/DropProgramTemplateRequest", item);
}
function EditProgramTemplateRequest(item) {
  return client.post("Dictionary/EditProgramTemplateRequest", item);
}
function NewProgramTemplateDetailRequest(item) {
  return client.post("Dictionary/NewProgramTemplateDetailRequest", item);
}
function DropProgramTemplateDetailRequest(item) {
  return client.post("Dictionary/DropProgramTemplateDetailRequest", item);
}
function EditProgramTemplateDetailRequest(item) {
  return client.post("Dictionary/EditProgramTemplateDetailRequest", item);
}
function RejectType(item) {
  return client.post("Dictionary/RejectType", item);
}
function DropRejectTypeRequest(item) {
  return client.post("Dictionary/DropRejectTypeRequest", item);
}
function EditRejectTypeRequest(item) {
  return client.post("Dictionary/EditRejectTypeRequest", item);
}
function NewRejectTypeRequest(item) {
  return client.post("Dictionary/NewRejectTypeRequest", item);
}

function ComplaintTemplateDetail(item) {
  return client.post("Dictionary/ComplaintTemplateDetail", item);
}
function ComplaintTemplate(item) {
  return client.post("Dictionary/ComplaintTemplate", item);
}
function NewComplaintTemplateRequest(item) {
  return client.post("Dictionary/NewComplaintTemplateRequest", item);
}
function DropComplaintTemplateRequest(item) {
  return client.post("Dictionary/DropComplaintTemplateRequest", item);
}
function EditComplaintTemplateRequest(item) {
  return client.post("Dictionary/EditComplaintTemplateRequest", item);
}
function NewComplaintTemplateDetailRequest(item) {
  return client.post("Dictionary/NewComplaintTemplateDetailRequest", item);
}
function DropComplaintTemplateDetailRequest(item) {
  return client.post("Dictionary/DropComplaintTemplateDetailRequest", item);
}
function EditComplaintTemplateDetailRequest(item) {
  return client.post("Dictionary/EditComplaintTemplateDetailRequest", item);
}
function MedicineByName(item) {
  return client.post("Dictionary/MedicineByName", item);
}
function DropMedicineRequest(item) {
  return client.post("Dictionary/DropMedicineRequest", item);
}
function EditMedicineRequest(item) {
  return client.post("Dictionary/EditMedicineRequest", item);
}
function NewMedicineRequest(item) {
  return client.post("Dictionary/NewMedicineRequest", item);
}
function ExceptionType(item) {
  return client.post("Dictionary/ExceptionType", item);
}
function DropExceptionTypeRequest(item) {
  return client.post("Dictionary/DropExceptionTypeRequest", item);
}
function EditExceptionTypeRequest(item) {
  return client.post("Dictionary/EditExceptionTypeRequest", item);
}
function NewExceptionTypeRequest(item) {
  return client.post("Dictionary/NewExceptionTypeRequest", item);
}
function GroupDescriptionDetail(item) {
  return client.post("Dictionary/GroupDescriptionDetail", item);
}
function GroupDescription(item) {
  return client.post("Dictionary/GroupDescription", item);
}
function NewGroupDescriptionRequest(item) {
  return client.post("Dictionary/NewGroupDescriptionRequest", item);
}
function DropGroupDescriptionRequest(item) {
  return client.post("Dictionary/DropGroupDescriptionRequest", item);
}
function EditGroupDescriptionRequest(item) {
  return client.post("Dictionary/EditGroupDescriptionRequest", item);
}
function NewGroupDescriptionDetailRequest(item) {
  return client.post("Dictionary/NewGroupDescriptionDetailRequest", item);
}
function DropGroupDescriptionDetailRequest(item) {
  return client.post("Dictionary/DropGroupDescriptionDetailRequest", item);
}
function EditGroupDescriptionDetailRequest(item) {
  return client.post("Dictionary/EditGroupDescriptionDetailRequest", item);
}
function Bank(item) {
  return client.post("Dictionary/Bank", item);
}
function Companies(item) {
  return client.post("Dictionary/Companies", item);
}
function CompaniesByAttribute(item) {
  return client.post("Dictionary/GetCompaniesByAttribute", item);
}
function CompanyTypes(item) {
  return client.post("Dictionary/GetCompanyTypes", item);
}
function Currency(item) {
  return client.post("Dictionary/Currency", item);
}
function ClinicTemplate(item) {
  return client.post("Dictionary/ClinicTemplate", item);
}
function NewClinicTemplateRequest(item) {
  return client.post("Dictionary/NewClinicTemplateRequest", item);
}
function DropClinicTemplateRequest(item) {
  return client.post("Dictionary/DropClinicTemplateRequest", item);
}
function EditClinicTemplateRequest(item) {
  return client.post("Dictionary/EditClinicTemplateRequest", item);
}
function ClinicListTemplateDetail(item) {
  return client.post("Dictionary/ClinicListTemplateDetail", item);
}
function NewClinicListTemplateDetailRequest(item) {
  return client.post("Dictionary/NewClinicListTemplateDetailRequest", item);
}
function DropClinicListTemplateDetailRequest(item) {
  return client.post("Dictionary/DropClinicListTemplateDetailRequest", item);
}
function EditClinicListTemplateDetailRequest(item) {
  return client.post("Dictionary/EditClinicListTemplateDetailRequest", item);
}
function ComplaintTemplateDetailList(item) {
  return client.post("Dictionary/ComplaintTemplateDetailList", item);
}
function DiaqnosByName(item) {
  return client.post("Dictionary/DiaqnosByName", item);
}
function ComplaintList(item) {
  return client.post("Dictionary/ComplaintList", item);
}
function MedicineBySearch(item) {
  return client.post("Dictionary/MedicineBySearch", item);
}
function DoctorByName(item) {
  return client.post("Dictionary/DoctorByName", item);
} 
function ExpertiseTmplsItem(item) {
  return client.post("Dictionary/ExpertiseTmplsItem", item);
}



//Client Service Zbt End

export default {
  Login,
  ServiceClass,
  Companies,
  CompaniesByAttribute,
  CompanyTypes,
  Currency,
  Bank,
  Service,
  NewServiceClassRequest,
  DropServiceClassRequest,
  EditServiceClassRequest,
  NewServiceRequest,
  DropServiceRequest,
  EditServiceRequest,
  ServiceByName,
  DoctorByName,
  ServiceByClass,
  ServiceReportTemplate,
  NewServiceReportTemplateRequest,
  DropServiceReportTemplateRequest,
  EditServiceReportTemplateRequest,
  ServiceReportTemplateDetail,
  NewServiceReportTemplateDetailRequest,
  DropServiceReportTemplateDetailRequest,
  ServiceClaimTemplate,
  NewServiceClaimTemplateRequest,
  DropServiceClaimTemplateRequest,
  EditServiceClaimTemplateRequest,
  ServiceClaimTemplateDetail,
  NewServiceClaimTemplateDetailRequest,
  DropServiceClaimTemplateDetailRequest,
  Position,
  NewPositionRequest,
  DropPositionRequest,
  EditPositionRequest,
  Department,
  NewDepartmentRequest,
  DropDepartmentRequest,
  EditDepartmentRequest,
  Doctor,
  NewDoctorRequest,
  DropDoctorRequest,
  EditDoctorRequest,
  ProgramTemplate,
  NewProgramTemplateRequest,
  DropProgramTemplateRequest,
  EditProgramTemplateRequest,
  ProgramTemplateDetail,
  NewProgramTemplateDetailRequest,
  DropProgramTemplateDetailRequest,
  EditProgramTemplateDetailRequest,
  RejectType,
  NewRejectTypeRequest,
  DropRejectTypeRequest,
  EditRejectTypeRequest,
  ComplaintTemplate,
  NewComplaintTemplateRequest,
  DropComplaintTemplateRequest,
  EditComplaintTemplateRequest,
  ComplaintTemplateDetail,
  NewComplaintTemplateDetailRequest,
  DropComplaintTemplateDetailRequest,
  EditComplaintTemplateDetailRequest,
  MedicineByName,
  NewMedicineRequest,
  DropMedicineRequest,
  EditMedicineRequest,
  ExceptionType,
  NewExceptionTypeRequest,
  DropExceptionTypeRequest,
  EditExceptionTypeRequest,
  GroupDescription,
  NewGroupDescriptionRequest,
  DropGroupDescriptionRequest,
  EditGroupDescriptionRequest,
  GroupDescriptionDetail,
  NewGroupDescriptionDetailRequest,
  DropGroupDescriptionDetailRequest,
  EditGroupDescriptionDetailRequest,
  ClinicTemplate,
  NewClinicTemplateRequest,
  DropClinicTemplateRequest,
  EditClinicTemplateRequest,
  ClinicListTemplateDetail,
  NewClinicListTemplateDetailRequest,
  DropClinicListTemplateDetailRequest,
  EditClinicListTemplateDetailRequest,
  ExpertiseTmplsItem,
  ComplaintTemplateDetailList,
  DiaqnosByName,
  ComplaintList,
  MedicineBySearch
};
